﻿import { faSearch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Space } from "antd";
import { func, object, string } from "prop-types";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { FilterWrapper, SearchInput } from "../styled";

export const TableSearchFilter = ({
  inputRef,
  onSearch,
  onReset,
  confirm,
  defaultValue,
}) => {
  const intl = useIntl();
  const [value, setValue] = useState(defaultValue || "");

  const buttonRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      buttonRef.current.focus();
    }
  }, [inputRef]);

  const handleSearch = () => {
    confirm();
    onSearch(value);
  };

  const handleReset = () => {
    setValue("");
    confirm();
    onReset();
  };

  return (
    <FilterWrapper>
      <SearchInput>
        <Input
          ref={inputRef}
          placeholder={`Search`}
          value={value}
          data-test-id={`input-projects-table`}
          onChange={(e) => setValue(e.target.value)}
          onPressEnter={handleSearch}
        />
      </SearchInput>

      <Space>
        <Button
          data-test-id="search-button"
          type="primary"
          onClick={handleSearch}
          icon={<FontAwesomeIcon icon={faSearch} />}
          size="small"
          ref={buttonRef}
        >
          {intl.formatMessage({ id: "general.search" })}
        </Button>
        <Button data-test-id="reset-button" onClick={handleReset} size="small">
          {intl.formatMessage({ id: "general.reset" })}
        </Button>
      </Space>
    </FilterWrapper>
  );
};

TableSearchFilter.propTypes = {
  inputRef: object,
  onSearch: func,
  onReset: func,
  confirm: func,
  defaultValue: string,
};
